/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UserPermissions, permissionGroups } from '../../lib/wwg.permissions';
import { Initiative } from '../../lib/wwg.classes';

@Component({
  selector: 'wwg-user-permissions',
  templateUrl: './user-permissions.component.html',
})

export class UserPermissionsComponent {

  public permissionGroups = permissionGroups;
  public items: UserPermissions[] = [];
  public initiativeId: string;
  public permissions: string[];

  @Input() public disabled = false;
  @Input() public initiatives: Initiative[] = [];

  @Input() get model() {
    return this.items;
  }

  @Output() modelChange = new EventEmitter();

  set model(val) {
    this.items = val;
    this.modelChange.emit(this.items);
  }

  public removeValue(index: number) {
    this.items.splice(index, 1);
  }

  addPermission() {
    this.items.push({
      initiativeId: this.initiativeId,
      permissions: this.permissions
    });

    this.initiativeId = undefined;
    this.permissions = [];
  }

  getName(initiativeId: string) {
    const initiative = this.initiatives.find(i => i._id === initiativeId);
    return initiative ? initiative.name : 'Reporting Level';
  }
}
